import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  class: "box-actions"
}
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "periods" }
const _hoisted_6 = { class: "description" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "infos" }
const _hoisted_10 = { class: "group" }
const _hoisted_11 = { class: "box progress" }
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "box dates" }
const _hoisted_14 = { class: "left" }
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "item" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = { class: "right" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "group" }
const _hoisted_24 = { class: "box" }
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "box" }
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { class: "box" }
const _hoisted_29 = { class: "value" }
const _hoisted_30 = { class: "box" }
const _hoisted_31 = { class: "value" }
const _hoisted_32 = { class: "box" }
const _hoisted_33 = { class: "value" }

import store from "@/store";
import { computed, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";

import { toast } from "@/common/utils/toast";
import { getDate, getHour, getDifference } from "@/common/utils/dates";

import {
  baseConfirm,
  baseDate,
  baseTextarea,
  svgIcon,
} from "@/common/components";

import {
  evaluationStart,
  evaluationCancel,
  evaluationFinish,
  evaluationPatch,
} from "@/common/api/rest/evaluation/evaluation";

import { EvaluationType } from "@/common/types/evaluation";


export default /*@__PURE__*/_defineComponent({
  __name: 'infos',
  props: {
    data: {},
    width: { default: "100%" },
    showTitle: { type: Boolean, default: true },
    actionShow: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const emit = __emit;

const props = __props;

const payload = ref({
  period_start_date: "",
  period_end_date: "",
  description: "",
});

const showConfirmStart = ref(false);
const showConfirmFinish = ref(false);
const showConfirmCancel = ref(false);

const accountId = computed(() => route.params.id as string);

function checkOptionsPermission() {
  return true;
  // return store.getters.type === "ADMIN" || store.getters.type === "MANAGER";
}

function showActions(status: string) {
  return status === "PENDING" || status === "STARTED";
}

function back() {
  router.push(`/${accountId.value}/cockpit`);
}

function patchData(payload: Partial<EvaluationType>) {
  if (!props.data) return;

  evaluationPatch(accountId.value, props.data.evaluation_id, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        emit("update-data");
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function startEvaluation() {
  showConfirmStart.value = true;
}

function startEvaluationCancel() {
  showConfirmStart.value = false;
}

function startEvaluationConfirm() {
  if (!props.data) return;

  startEvaluationCancel();
  store.commit("SET_LOADING", true);

  evaluationStart(accountId.value, props.data.evaluation_id)
    .then((response) => {
      const { success, data } = response;

      if (success) {
        emit("update-data");
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function finishEvaluation() {
  showConfirmFinish.value = true;
}

function finishEvaluationCancel() {
  showConfirmFinish.value = false;
}

function finishEvaluationConfirm() {
  if (!props.data) return;

  finishEvaluationCancel();
  store.commit("SET_LOADING", true);

  evaluationFinish(accountId.value, props.data.evaluation_id)
    .then((response) => {
      const { success, data } = response;

      if (success) {
        emit("update-data");
        back();
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function cancelEvaluation() {
  showConfirmCancel.value = true;
}

function cancelEvaluationCancel() {
  showConfirmCancel.value = false;
}

function cancelEvaluationConfirm() {
  if (!props.data) return;

  cancelEvaluationCancel();
  store.commit("SET_LOADING", true);

  evaluationCancel(accountId.value, props.data.evaluation_id)
    .then((response) => {
      const { success, data } = response;

      if (success) {
        emit("update-data");
        back();
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function updatePeriod(key: keyof typeof payload.value) {
  patchData({ [key]: payload.value[key] });
}

function updateDescription() {
  patchData({ description: payload.value.description });
}

watchEffect(() => {
  if (props.data) {
    const { period_start_date, period_end_date, description } = props.data;
    payload.value = {
      period_start_date: period_start_date ?? "",
      period_end_date: period_end_date ?? "",
      description: description ?? "",
    };
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.data)
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          class: _normalizeClass(["tab-component", { width: __props.width }])
        }, [
          (checkOptionsPermission() && showActions(__props.data.status))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (__props.showTitle)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(t)("common.labels.options")), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                  (__props.actionShow)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (props.data?.start_date)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-black",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (finishEvaluation()))
                            }, [
                              _createVNode(_unref(svgIcon), {
                                icon: "pause",
                                size: "1.5rem"
                              }),
                              _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.finish").toUpperCase()), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "btn btn-primary",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (startEvaluation()))
                            }, [
                              _createVNode(_unref(svgIcon), {
                                icon: "play",
                                size: "1.5rem"
                              }),
                              _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.play").toUpperCase()), 1)
                            ])),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (cancelEvaluation()))
                        }, [
                          _createVNode(_unref(svgIcon), {
                            icon: "close",
                            size: "1.5rem"
                          }),
                          _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.cancel").toUpperCase()), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(baseDate), {
                modelValue: payload.value.period_start_date,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => ((payload.value.period_start_date) = $event)),
                  _cache[4] || (_cache[4] = ($event: any) => (updatePeriod('period_start_date')))
                ],
                value: payload.value.period_start_date,
                "value-mask": "YYYY-MM-DD",
                placeholder: "--/--/----"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("evaluation.labels.start_forecast")), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "value"]),
              _createVNode(_unref(baseDate), {
                modelValue: payload.value.period_end_date,
                "onUpdate:modelValue": [
                  _cache[5] || (_cache[5] = ($event: any) => ((payload.value.period_end_date) = $event)),
                  _cache[6] || (_cache[6] = ($event: any) => (updatePeriod('period_end_date')))
                ],
                value: payload.value.period_end_date,
                "value-mask": "YYYY-MM-DD",
                placeholder: "--/--/----"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("evaluation.labels.termination")), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "value"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(baseTextarea), {
                modelValue: payload.value.description,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((payload.value.description) = $event)),
                value: payload.value.description,
                placeholder: _unref(t)('common.placeholders.describe'),
                onChange: _cache[8] || (_cache[8] = ($event: any) => (updateDescription()))
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "value", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)("common.labels.infos")), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.progress")), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(__props.data.total_progress) + "%", 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.dates")), 1),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)("common.labels.start")) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_unref(getDate)(__props.data.start_date)) + " - " + _toDisplayString(_unref(getHour)(__props.data.start_date)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)("common.labels.termination")) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_unref(getDate)(__props.data.finish_date)) + " - " + _toDisplayString(_unref(getHour)(__props.data.finish_date)), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.total_duration")), 1),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_unref(svgIcon), {
                        icon: "time-b",
                        size: "2rem"
                      }),
                      (!__props.data.start_date)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, " 0m "))
                        : _createCommentVNode("", true),
                      (__props.data.start_date && !__props.data.end_date)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(getDifference)(
                        __props.data.start_date,
                        new Date().toISOString(),
                        false,
                      ).text), 1))
                        : _createCommentVNode("", true),
                      (__props.data.start_date && __props.data.end_date)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_unref(getDifference)(__props.data.start_date, __props.data.end_date, false).text), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.analysis")), 1),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(__props.data.total_analysis), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.crew")), 1),
                  _createElementVNode("div", _hoisted_27, _toDisplayString(__props.data.total_crew), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.employees")), 1),
                  _createElementVNode("div", _hoisted_29, _toDisplayString(__props.data.total_employee), 1)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.equipments")), 1),
                  _createElementVNode("div", _hoisted_31, _toDisplayString(__props.data.total_equipment), 1)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.samples")), 1),
                  _createElementVNode("div", _hoisted_33, _toDisplayString(__props.data.total_sample), 1)
                ])
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_unref(baseConfirm), {
      show: showConfirmStart.value,
      title: _unref(t)('evaluation.modal.titles.start_evaluation').toUpperCase(),
      message: _unref(t)('evaluation.modal.messages.start_evaluation'),
      onCancel: _cache[9] || (_cache[9] = ($event: any) => (startEvaluationCancel())),
      onConfirm: _cache[10] || (_cache[10] = ($event: any) => (startEvaluationConfirm()))
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseConfirm), {
      show: showConfirmFinish.value,
      title: _unref(t)('evaluation.modal.titles.finish_evaluation').toUpperCase(),
      message: _unref(t)('evaluation.modal.messages.finish_evaluation'),
      onCancel: _cache[11] || (_cache[11] = ($event: any) => (finishEvaluationCancel())),
      onConfirm: _cache[12] || (_cache[12] = ($event: any) => (finishEvaluationConfirm()))
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseConfirm), {
      show: showConfirmCancel.value,
      title: _unref(t)('evaluation.modal.titles.cancel_evaluation').toUpperCase(),
      message: _unref(t)('evaluation.modal.messages.cancel_evaluation'),
      onCancel: _cache[13] || (_cache[13] = ($event: any) => (cancelEvaluationCancel())),
      onConfirm: _cache[14] || (_cache[14] = ($event: any) => (cancelEvaluationConfirm()))
    }, null, 8, ["show", "title", "message"])
  ], 64))
}
}

})